module.exports = __webpack_public_path__ + "static/media/coupons-disabled-mobile.20aef56a.png";